import { Link } from 'react-router-dom';

export function CheckoutCancelPage() {
  return (
    <div className="py-16 text-center">
      <h1 className="text-xl font-bold text-ink">Checkout cancelled</h1>
      <p className="mt-2 text-sm text-ink-muted">No problem — you can upgrade anytime.</p>
      <Link to="/pricing" className="mt-6 inline-block rounded-lg border border-surface-200 px-6 py-2.5 text-sm font-semibold text-ink hover:bg-surface-100 transition">
        View Plans
      </Link>
    </div>
  );
}
